import _ from 'lodash';
import React from 'react';
import PropTypes, { string } from 'prop-types';
import ReactDom from 'react-dom';
import { StyleRoot } from 'radium';
import { push } from 'react-router-redux';
import color from 'color';

import * as styles from '../../../styles';
import { host, host_v2, imageUrl } from '../../../utilities/requests';
import CommentList from '../../../social/comment';
import Dialog from '../../../dialog/dialog';
import { request } from '../../../containers/actions';
import PrintStudentReport from './print_student';
import { ServerDate } from '../../../containers/ServerDate';
import {resizer1100} from '../../../responsiver'
import { PrintMyContent } from '../../../utilities/print';
import Portal from './PortalRoot';

export default class StudentReport extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static defaultProps = {
        urls: {},
    }
    constructor(props){
        super(props)
        this.fetchShabihSazReport = this.fetchShabihSazReport.bind(this);
        this.fetchStudyProposal = this.fetchStudyProposal.bind(this);
    }
    state = {
        currentTab: 0,
        currentMaterial: 0,
        shabihsazData:{},
        noImage: false,
        portalShow:false,
        showEntranceAnalyze : true,
        studyProposalData:null
    }
   



    componentDidMount() {
        
        if(this.props.examination.examination_type?.id !== 1 && this.props.examination.examination_type?.id !== 2 && this.props.examination.examination_type?.id !== 6){
            this.props.examination.participants = this.props.examination.participants_count;
        }
        this.fetchReport.bind(this)();
        this.fetchStudyProposal.bind(this);
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.student !== this.props.student ||
            (nextProps.examination && nextProps.examination.id) !==
            (this.props.examination && this.props.examination.id)) {
            this.setState({ data: undefined });
        }
    }

    componentDidUpdate(prevProps,prevState) {
        if (prevProps.student !== this.props.student ||
            (prevProps.examination && prevProps.examination.id) !==
            (this.props.examination && this.props.examination.id)) {
                if(this.props.examination.examination_type?.id !== 1 && this.props.examination.examination_type?.id !== 2 && this.props.examination.examination_type?.id !== 6){
                    this.props.examination.participants = this.props.examination.participants_count;
                }
            this.fetchReport.bind(this)();
            this.fetchStudyProposal.bind(this);
        }
        if (prevState.studyProposalData !== this.state.studyProposalData) {
            this.forceUpdate();
        }
    }

    getParticipants() {
        const reportParticipants = this.state.data?.participants;
        if (this.props.examination.examination_type?.id === 6) {
            return reportParticipants ?? '';
        }
        return this.props.examination.participants || reportParticipants || '';
    }

    async fetchReport() {
        if (!this.props.examination || _.keys(this.props.examination).length === 0) {
            this.setState({ data: undefined });
            return;
        }
        if (!this.props.autoRefresh)
            this.setState({ data: null });
        var showKey = false; 
        const response = await this.context.store.dispatch(request({
            path: `/examination/${this.props.examination.id}/report/student/`,
            body: { student: this.props.student, showKey: showKey },
        }));
        if (this.props.autoRefresh && !response.global.taraz) {
            this.timeoutId = setTimeout(this.fetchReport.bind(this), 6000);
        }
        //Global score correction
        //    response.global.score = (response.global.correct-(response.global.incorrect/3))/response.global.count;
        //    response.global.alternative_score = (response.global.correct)/response.global.count;
        //    if(response.global_score!==null)
        //    {
        //        response.global_score[0] = response.global.score;
        //    }
        this.setState({
            data: response,
            noImage: false,
        });
        if(this?.state?.data?.id && (this.props.examination.grades[0].id == 4 || this.props.examination.grades[0].id == 6 ) ){
            this.fetchShabihSazReport();
            this.fetchStudyProposal();
        }
    }
    
    fetchStudyProposal() {
            var token = this.context.store.getState().get('application').get('token');
            var auth = token.get('accessToken');
            fetch(`${host_v2}/api/StudyProposalApi/Process?examId=${this.props.examination.id}` + (this.props.student ? `&studentId=${this.props.student}` : ''), {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + auth,
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(data => {
                if(data.errorId == 0){
                    this.setState({ studyProposalData: data.result });
                }
            })
            .catch(error => console.error('Error:', error));
           
    }

    renderStudyProposal() {
        const data = this.state.studyProposalData;
        return (data != null && data?.studyProposals != null && data?.studyProposals.length > 0) ? (
            <span style={{ width: "100%" }}>
                <h2 style={{ clear: 'right', textAlign: 'center', fontWeight: '700', marginBottom: "1rem" }}>
                    دروس و مباحثی که  برای آزمون بعدی باید بیشتر مطالعه کنی
                </h2>

                <div style={{ overflow: "auto" }}>
                    <table style={{ ...styles.table, width: "100%", marginBottom: "1rem" }}>
                        <thead style={{ backgroundColor: '#cccccc' }}>
                            <tr style={styles.tr}>
                                <th style={styles.th}>ردیف</th>
                                <th style={styles.th}>درس</th>
                                <th style={styles.th}>اولویت</th>
                                <th style={styles.th}>مبحث</th>
                                {/* <th style={styles.th}>پیشنهاد مطالعه</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {data?.studyProposals?.map((proposal, proposalIndex) => (
                                proposal.offerForUser?.map((offer, offerIndex) => (
                                    <tr key={`${proposal.materialId}-${offer.subjectId || offerIndex}`} style={styles.tr}>
                                        {offerIndex === 0 && (
                                            <td
                                                style={styles.td}
                                                rowSpan={proposal.offerForUser?.length || 1}
                                            >
                                                {(proposalIndex + 1).toString().persian()}
                                            </td>
                                        )}
                                        
                                        {offerIndex === 0 && (
                                            <td
                                                style={styles.td}
                                                rowSpan={proposal.offerForUser?.length || 1}
                                            >
                                                {proposal.materialTitle || "-"}
                                            </td>
                                        )}
                                        <td style={styles.td}>{(offerIndex + 1).toString().persian() || "-"}</td>
                                        <td style={styles.td}>{offer.subjectTitle || "-"}</td>
                                        {/* <td style={styles.td}>{offer.proposal || "-"}</td> */}
                                    </tr>
                                ))
                            ))}
                        </tbody>
                    </table>
                </div>
            </span>
        ) : null;
    }


    sortExamMaterial(item){
        switch (item.id){
            case 53:
                return {order:0}
            case 37:
                return {order:1}
            case 20:
                return {order:2}
            case 21:
                return {order:3}
            case 18:
                return {order:4}
            case 11:
                return {order:5}
            case 36:
                return {order:6}
        }
    }

    renderProgressReport() {
        if (!this?.state?.data || this?.state?.data?.global == null)
            return null;
        const questionsPerColumn = this.props.examination.paper_type === 14 ? 50 : 30;
        const columns = this.props.examination.paper_type === 14 ? 6 : 4;
        let examinations = this.state.data?.global.examinations;
        examinations = examinations.filter((exam)=> exam[2] === this.props.examination.examination_type?.id)
        let minimumTaraz = _.min(_.map(examinations, i => i[1]));
        let maximumTaraz = _.max(_.map(examinations, i => i[1]));
        if (maximumTaraz - minimumTaraz < 2000) {
            minimumTaraz = (minimumTaraz + maximumTaraz) / 2 - 1000;
            maximumTaraz = (minimumTaraz + maximumTaraz) / 2 + 1000;
        }
        minimumTaraz = Math.round(minimumTaraz / 500) * 500;
        maximumTaraz = Math.round(maximumTaraz / 500) * 500;
        let examinationMaterial = [];
        _.map(this.props.examination.materials , (exam)=>{
            examinationMaterial.push({...exam , ...this.sortExamMaterial(exam)})
        })
        const materials = _.uniq(_.map(this.state.data.questions, 'material'));
        const showCoefficients = _.some(
            this.props.examination.materials_coefficients,
            value => value !== _.values(this.props.examination.materials_coefficients)[0],
        );
        const reportImageMobileStyle = {
            width:"300px" ,
        }
        const reportImageDesktopStyle={
            height: this.props.examination.paper_type === 14 ? '53em' : '38em',
            maxWidth: this.props.examination.paper_type === 14 ? '35em' : '28em',
        }
        const reportImageStyle = window.mobile ? reportImageMobileStyle: reportImageDesktopStyle;
        return <span style={{  width:"100%"}}>
                <div style={{ clear: 'right', textAlign: 'center', fontWeight: '700' , marginBottom:"1rem"}}>
                    {window.interpolate(
                        window.gettext('Ranks are based on %(analyzeModel)s!'),
                        { analyzeModel: this.props.examination.analyze_model === 1 ? window.gettext('Taraz') : window.gettext('Score') }, 
                        true,
                    )}
                </div>
            <div style={{overflow:"auto",display:"flex",justifyContent:"center" , marginBottom:"1rem"}}>
                <div style={{width:"100%"}}>
                <table style={styles.table}
                ref={(mainTable) => { this.mainTable = mainTable }}
                >
                    <thead style={{ backgroundColor: '#cccccc' }}> 
                    <tr>
                        <th rowSpan='2' style={{ ...styles.th, width: '12em' }}>
                            {window.gettext('Material')}
                        </th>
                        {_.map(
                            [
                                ...showCoefficients ? ['coefficient'] : [],
                                'count',
                                'correct',
                                'incorrect',
                                'empty',
                                'score',
                                'alternative_score',
                                'taraz',
                            ],
                            title => <th
                                key={title}
                                rowSpan='2'
                                style={{ ...styles.th, width: title.includes('score') ? '5.5em' : '4em' }}>
                                {window.gettext(_.startCase(title === 'score' ? 'Percent' : (title === 'alternative_score' ? 'Alternative Percent' : title)))}
                                {/* {window.gettext(_.startCase(title))} */}
                            </th>,
                        )}
                        {
                            !this.state.data.solo_exam ? <th
                                colSpan='3'
                                style={{ ...styles.th, width: '12em' }}>
                                {window.gettext('Rank')}
                            </th> : null
                        }

                    </tr>
                    {
                        !this.state.data.solo_exam ?
                            <tr>

                                <th style={{ ...styles.th, width: '4em' }}>
                                    {window.gettext('Class')}
                                </th>
                                <th style={{ ...styles.th, width: '4em' }}>
                                    {window.gettext('School')}
                                </th>
                                <th style={{ ...styles.th, width: '4em' }}>
                                    {window.gettext('Global')}
                                </th>
                            </tr>
                            :
                            <tr>
                                 <th style={{ ...styles.th, width: '4em' }}>
                                رتبه {window.gettext('Region')}
                                </th>
                                <th style={{ ...styles.th, width: '4em' }}>
                                رتبه {window.gettext('Global')}
                                </th>
                            </tr>
                    }

                    </thead>
                    <tbody>
                    {_.map(
                        [..._.sortBy(this.props.examination.examination_type?.id == 6 && this.props.examination.grades[0].title === "نهم" ? examinationMaterial :this.props.examination.materials,
                             material => this.props.examination.examination_type?.id == 6 && this.props.examination.grades[0].title === "نهم" ? material?.order : materials.indexOf(material.title)), 'global'],
                        material => {
                            const data = material === 'global'
                                ? (this.state.data?.global == undefined ? {} : this.state.data?.global)
                                : (this.state.data.materials != undefined && this.state.data.materials[material.id] != undefined) ? this.state.data.materials[material.id] : material;
                            return <tr
                                style={styles.tr}
                                key={material.id || material}>
                                <td style={{ ...styles.td, width: '12em', textAlign: 'right' }}>
                                    {material === 'global' ? window.gettext('All') : material.title.persian()}
                                </td>
                                {showCoefficients
                                    ? <td style={{ ...styles.td, width: '4em', textAlign: 'center' }}>
                                        {material === 'global'
                                            ? _.sum(_.map(this.props.examination?.materials_coefficients, value => Math.floor(Number(value)))).persian()
                                           : Math.floor(this.props.examination?.materials_coefficients[material.id])?.persian() ?? "-"
                                        }
                                    </td>
                                    : null
                                }
                                {_.map(
                                    ['count', 'correct', 'incorrect', 'empty', 'score', 'alternative_score', 'taraz'],
                                    (title, index) => <td
                                        key={'td-' + index}
                                        style={{
                                            ...styles.td,
                                            width: title.includes('score') ? '5.5em' : '4em',
                                            textAlign: 'center',
                                        }}>
                                        {(value => value !== undefined
                                            ? title.includes('score')
                                                ? (Math.min(1, Math.max(-1, value))).toPercent().persian()
                                                : value.toFixed().persian()
                                            : '-'
                                        )(data[title])}
                                    </td>,
                                )}
                                {
                                    !this.state.data.solo_exam ?
                                        _.map(
                                            ['class', 'school', 'global'],
                                            (title, index) => <td
                                                key={'td-' + index}
                                                style={{
                                                    ...styles.td,
                                                    width: title.includes('score') ? '5.5em' : '4em',
                                                    textAlign: 'center',
                                                }}>
                                                {(value => value !== undefined
                                                    ? value.toFixed().persian()
                                                    : '-'
                                                )((data[title] || {}).rank)}
                                            </td>,
                                        ) :
                                        _.map(
                                            ['region','global'],
                                            (title, index) => <td
                                                key={'td-' + index}
                                                style={{
                                                    ...styles.td,
                                                    width: title.includes('score') ? '5.5em' : '4em',
                                                    textAlign: 'center',
                                                }}>
                                                {(value => value !== undefined
                                                    ? value.toFixed().persian()
                                                    : '-'
                                                )((data[title] || {}).rank)}
                                            </td>,
                                        )
                                }
                            </tr>;
                        },
                    )}
                    </tbody>
                </table>
                </div>
            </div>
            {/* {
            this.props.examination.examination_type.id === 6 &&  <div style={{display:"flex" , justifyContent:"center" , width:"100%"}}>
                 <table style={{ ...styles.table, marginTop: '1em' ,width:`${this?.mainTable?.clientWidth}px` }}>
                     <thead style={{ backgroundColor: '#cccccc' }}>
                         {_.map(this.state.shabihsazData.examinations , (item)=>(
                             <th style={{ ...styles.th, width: '12em' }} colSpan={3}>
                                 {window.gettext(`Ranking with schools formula ${item.title}`)}
                             </th>
                         ))}
                     </thead>
                     <tbody>
                         <tr style={styles.tr}>
                             {_.map(this.state.shabihsazData.examinations  , _ =>
                                 ["تراز","رتبه کل" ,`رتبه در ${this.state.shabihsazData.gender == 1 ? "پسران" : "دختران"}`].map((item)=>(
                                     <th style={{ ...styles.td, width: '12em', textAlign: 'center'}}>
                                         {window.gettext(item)}
                                     </th>
                             ))
                             )}
 
                         </tr>
                         <tr style={styles.tr}>
                             {_.map(this.state.shabihsazData.examinations  , (item)=>(
                                 <>
                                     <td style={{ ...styles.td, width: '12em', textAlign: 'center'}}>
                                         {window.gettext(item.taraz.toFixed().persian())}
                                     </td>
                                     <td style={{ ...styles.td, width: '12em', textAlign: 'center'}}>
                                         {window.gettext(item.rank.global_.persian())}
                                     </td>
                                     <td style={{ ...styles.td, width: '12em', textAlign: 'center'}}>
                                         {window.gettext(item.rank.gender.persian())}
                                     </td>
                                 </>
                             ))}
                         </tr>
                     </tbody>
                 </table>
            </div>} */}
            <Dialog
                isOpen={this.state.complaintDialog}>
                {/* onClose={() => this.setState({complaintDialog: false})}> */}
                <span>
                    <div style={{ width: '45em' }}>
                        {!this.props.examination.complaint
                            ? <span>{window.gettext('Complaints are closed for this examination')}</span>
                            : null
                        }
                        <CommentList
                            target={['multiple-choice-paper', this.state.data.id, 'complaint']}
                            submitMessage={window.gettext('We will examine the complaint you submitted!')}
                            readonly={!this.props.examination.complaint}
                            actions={[
                                {
                                    icon: comment => comment.extra.accepted
                                        ? 'fa-check-circle'
                                        : comment.extra.accepted === false
                                            ? 'fa-times-circle'
                                            : 'fa-info-circle',
                                    action: async (comment, props) => {
                                        await this.context.store.dispatch(request({
                                            path: `/comment/${comment.id}/`,
                                            method: 'PATCH',
                                            body: {
                                                extra: {
                                                    ...comment.extra,
                                                    accepted: comment.extra.accepted
                                                        ? false
                                                        : comment.extra.accepted === false
                                                            ? null
                                                            : true,
                                                }
                                            },
                                        }));
                                        props.refresh();
                                    },
                                },
                            ]}
                        />
                    </div>
                    <br />
                    <div style={styles.dialogButtonContainer}>
                        <input
                            key='close'
                            type='button'
                            style={styles.dialogButton}
                            value={'انصراف'}
                            onClick={() => this.setState({ complaintDialog: false })}
                        />
                    </div>
                </span>
                <span>{window.gettext('Complaint')}</span>
                <div>
                    <button
                        style={{
                            ...styles.button,
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                        onClick={() => this.setState({ complaintDialog: true })}>
                        {window.gettext('Complaint')}
                    </button>
                </div>
            </Dialog>
            <div style={{width:"100%" , display:"flex" , justifyContent:"center"}}>
            {!this.props.examination.show_key || this.props.examination.show_key == false 
            ? 
            <span>جزئیات بیشتر کارنامه شما پس از پایان زمان آزمون نمایش داده می شوند.</span> 
            :  
            <span>
                {this.props.examination.special_general
                    ? <table style={{ ...styles.table, marginTop: '1em' , marginBottom:"1em" }}>
                        <thead style={{ backgroundColor: '#cccccc' }}>
                            <tr>
                                <th rowSpan='2' style={{ ...styles.th, width: '12em' }}>
                                    {window.gettext('Material Type')}
                                </th>
                                {_.map(
                                    [
                                        ...showCoefficients ? ['coefficient'] : [],
                                        'count',
                                        'correct',
                                        'incorrect',
                                        'empty',
                                        'score',
                                        'alternative_score',
                                        'taraz',
                                    ],
                                    title => <th
                                        key={title}
                                        rowSpan='2'
                                        style={{ ...styles.th, width: title.includes('score') ? '5.5em' : '4em' }}>
                                        {window.gettext(_.startCase(title))}
                                    </th>,
                                )}
                                <th
                                    colSpan='3'
                                    style={{ ...styles.th, width: '12em' }}>
                                    {window.gettext('Rank')}
                                </th>
                            </tr>
                            <tr>
                                <th style={{ ...styles.th, width: '4em' }}>
                                    {window.gettext('Class')}
                                </th>
                                <th style={{ ...styles.th, width: '4em' }}>
                                    {window.gettext('School')}
                                </th>
                                <th style={{ ...styles.th, width: '4em' }}>
                                    {window.gettext('Global')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {_.map(
                                this.state.data.material_types,
                                (__, materialTypeId) => {
                                    const data = this.state.data.material_types[materialTypeId];
                                    return <tr
                                        style={styles.tr}
                                        key={materialTypeId}>
                                        <td style={{ ...styles.td, width: '12em', textAlign: 'right' }}>
                                            {materialTypeId === '1' ? window.gettext('General') : window.gettext('Special')}
                                        </td>
                                        {_.map(
                                            [
                                                ...showCoefficients ? ['coefficient'] : [],
                                                'count',
                                                'correct',
                                                'incorrect',
                                                'empty',
                                                'score',
                                                'alternative_score',
                                                'taraz',
                                            ],
                                            (title, index) => <td
                                                key={'td-' + index}
                                                style={{
                                                    ...styles.td,
                                                    width: title.includes('score') ? '5.5em' : '4em',
                                                    textAlign: 'center',
                                                }}>
                                                {(value => value !== undefined
                                                    ? title.includes('score')
                                                        ? value.toPercent().persian()
                                                        : value.toFixed().persian()
                                                    : '-'
                                                )(data[title])}  
                                            </td>,
                                        )}
                                        {_.map(
                                            ['class', 'school', 'global'],
                                            (title, index) => <td
                                                key={'td-' + index}
                                                style={{
                                                    ...styles.td,
                                                    width: title.includes('score') ? '5.5em' : '4em',
                                                    textAlign: 'center',
                                                }}>
                                                {(value => value !== undefined
                                                    ? value.toFixed().persian()
                                                    : '-'
                                                )((data[title] || {}).rank)}
                                            </td>,
                                        )}
                                    </tr>;
                                },
                            )}
                        </tbody>
                    </table>
                    : null
                }
                <div
  style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    overflowX: 'auto',  
    overflowY: 'hidden',
  }}
>
  {/* بخش اول: نمودار میله‌ای */}
  <div
    style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    <svg
      style={{
        width: '70%',
        maxWidth: '700px', 
        height: '20em',
        overflow: 'visible',
        direction: 'ltr',
      }}
      viewBox={`0 -12 ${20 + (this.props.examination.materials.length + 1) * 30 + 20} 150`}
      preserveAspectRatio="xMidYMid meet"
    
                            >
                            <text
                                style={{ fill: '#00ff44' }}
                                x={(this.props.examination.materials.length + 1) * 30}
                                y='-12'
                                dominantBaseline='hanging'
                                textAnchor='start'
                                fontSize='.6em'>
                                {window.gettext('Global')}
                            </text>,
                            <text
                                style={{ fill: '#7cd0eb' }}
                                x={(this.props.examination.materials.length + 1) * 30 - 50}
                                y='-12'
                                dominantBaseline='hanging'
                                textAnchor='start'
                                fontSize='.6em'>
                                {window.gettext('Student')}
                            </text>,
                            {_.map(Array(6), (__, index) => [
                                <text key={index + '-1'} x='18' y={index * 20} textAnchor='end' dominantBaseline='middle' fontSize='.6em'>
                                    ٪{index > 5 ? '-' : ''}{Math.abs((100 - index * 20)).persian()}
                                </text>,
                                <line key={index + '-2'} x1='19' y1={index * 20} x2='21' y2={index * 20} strokeWidth='1' stroke='black' />,
                                <line
                                    key={index + '-3'}
                                    style={{
                                        strokeWidth: '1',
                                        stroke: 'rgba(0, 0, 0, .3)',
                                        strokeDasharray: '1',
                                    }}
                                    x1='20'
                                    y1={index * 20}
                                    x2={(this.props.examination.materials.length + 1) * 30 + 20}
                                    y2={index * 20} />,
                            ])}
                            {_.map([...this.props.examination.materials, 'global'], (material, index) => {
                                const data = material === 'global'
                                    ? (this.state.data?.global == undefined ? {} : this.state.data?.global)
                                    : ((this.state.data.materials != undefined && this.state.data.materials[material.id] != undefined) ? this.state.data.materials[material.id] : material);
                                return [
                                    <text
                                        key={material}
                                        x={35 + 30 * index}
                                        y='104'
                                        transform={`rotate(60, ${35 + 30 * index}, 104)`}
                                        textAnchor='end'
                                        fontSize='.5em'
                                        class="rtl-style">
                                        {material === 'global' ? window.gettext('All') : (material.title.substring(0, 8) +
                                            (material.title.length > 8 ? '...' : ''))}
                                    </text>,
                                    data.score >= 0
                                        ? <rect
                                            style={{ fill: '#7cd0eb', stroke: 'black', strokeWidth: '.5' }}
                                            key={material + '-student'}
                                            x={25 + 30 * index}
                                            y={100 - Math.min(data.score, 1) * 100}
                                            width={10}
                                            height={Math.min(data.score, 1) * 100} />
                                        : <rect
                                            style={{ fill: '#7cd0eb', stroke: 'black', strokeWidth: '.5' }}
                                            key={material + '-student'}
                                            x={25 + 30 * index}
                                            y={100}
                                            width={10}
                                            height={-Math.max(-1, data.score) * 100} />,
                                    this.state.data?.global_score[material.id || 0] >= 0
                                        ? <rect
                                            style={{ fill: '#00ff44', stroke: 'black', strokeWidth: '.5' }}
                                            key={material + '-global'}
                                            x={35 + 30 * index}
                                            y={100 - this.state.data?.global_score[material.id || 0] * 100}
                                            width={10}
                                            height={Math.min(1, this.state.data?.global_score[material.id || 0]) * 100 || 0} />
                                        : <rect
                                            style={{ fill: '#00ff44', stroke: 'black', strokeWidth: '.5' }}
                                            key={material + '-global'}
                                            x={35 + 30 * index}
                                            y={100}
                                            width={10}
                                            height={Math.max(-1, -this.state.data?.global_score[material.id || 0]) * 100 || 0} />,
                                ];
                            })}
                            <line x1='20' y1='-10' x2='20' y2='116' strokeWidth='1' stroke='black' />
                            <line
                                x1='20'
                                y1='100'
                                x2={(this.props.examination.materials.length + 1) * 30 + 20}
                                y2='100'
                                strokeWidth='1'
                                stroke='black' />
                        </svg>
                    </div>
                {/* ------نمودار میله ای----------- */}
                    <div
                        style={{
                            float: 'right',
                            clear: 'left',
                            display: 'flex',
                            //width: '50%',
                        }}>
                        {examinations != null && examinations.length > 0
                            ? _.uniqBy(examinations, (item) => item[2] ).map((groupedExam)=> {

                                let filteredExaminations = examinations.filter((exam)=>exam[2]==groupedExam[2] && !exam[0].includes('پیش آزمون'))
                                if(filteredExaminations.length === 0)
                                    return null;
                                return [<p></p>,<svg
                                style={{
                                    float: 'right',
                                    width: 'auto',
                                    height: '20em',
                                    overflow: 'visible',
                                    direction: 'ltr',
                                    margin: '0 20px 40px 20px'
                                }}
                                viewBox={`0 -12 ${20 + (filteredExaminations.length + 1) * 30 + 20} 150`}
                                preserveAspectRatio='none'>
                                    {/* taraz-all */}
                                {_.map(Array(6), (__, index) => [
                                    <text key={index + '-1'} x='18' y={index * 20} textAnchor='end' dominantBaseline='middle' fontSize='.6em'>
                                        {(((index * minimumTaraz) +
                                            ((5 - index) * maximumTaraz)) / 5).toFixed().persian()}
                                    </text>,
                                    <line key={index + '-2'} x1='19' y1={index * 20} x2='21' y2={index * 20} strokeWidth='1' stroke='black' />,
                                    <line
                                        key={index + '-3'}
                                        style={{
                                            strokeWidth: '1',
                                            stroke: 'rgba(0, 0, 0, .3)',
                                            strokeDasharray: '1',
                                        }}
                                        x1='20'
                                        y1={index * 20}
                                        x2={(filteredExaminations.length + 1) * 30 + 20}
                                        y2={index * 20} />,
                                ])}
                                {_.map(
                                    _.zip(filteredExaminations, _.concat(_.slice(filteredExaminations, 1), [[]])),
                                    ([[title, taraz, typeId,id], [, nextTaraz]], index) => {
                                        const elements = [
                                            <text
                                                key={index}
                                                x={35 + 30 * index}
                                                y='104'
                                                transform={`rotate(60, ${35 + 30 * index}, 104)`}
                                                textAnchor='end'
                                                fontSize='.4em'
                                                class="rtl-style">
                                                {title}
                                            </text>,
                                        ];
                                        elements.push(<a href={`/reports/multiple-choice/${id}/report/` + (this.props.student !== undefined ? `${this.props.student}/` : ``)} rel="noreferrer" target='_blank'><circle
                                            key={index + '-dot'}
                                            cx={35 + 30 * index}
                                            cy={100 - (taraz - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                            r={2}
                                            style={{ fill: '#7cd0eb' }} /></a>);
                                        if (nextTaraz)
                                            elements.push(<line
                                                key={index + '-line'}
                                                x1={35 + 30 * index}
                                                y1={100 - (taraz - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                                x2={35 + 30 * (index + 1)}
                                                y2={100 - (nextTaraz - minimumTaraz) / (maximumTaraz - minimumTaraz) * 100}
                                                strokeWidth='1'
                                                stroke='#7cd0eb'
                                            />);
                                        return elements;
                                    },
                                )}
                                <line x1='20' y1='-10' x2='20' y2='116' strokeWidth='1' stroke='black' />
                                <line
                                    x1='20'
                                    y1='100'
                                    x2={(filteredExaminations.length + 1) * 30 + 20}
                                    y2='100'
                                    strokeWidth='1'
                                    stroke='black' />
                            </svg>]})
                            : null
                        }
                    </div>
                </div>
                <div className='container-img-section'>
                    {this.state.noImage
                        ? <div
                            style={{
                                display: 'flex',
                                height: this.props.examination.paper_type === 14 ? '53em' : '38em',
                                width: "100%",
                                marginLeft: '1em',
                                border: '.0625em solid #9a9a9a',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                            {window.gettext('No paper image for this examination!')}
                        </div>
                        : <img
                            style={{
                                display: 'block',
                               ...reportImageStyle,
                                marginLeft: '1em',
                                float: 'right',
                            }}
                            src={imageUrl(this.state.data.image, {
                                height: (this.props.examination.paper_type === 14 ? 53 : 38) * 16,
                                type: 'contain',
                            })}
                            onError={() => this.setState({ noImage: true })}
                        />
                    }
                    <div 
  style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',     
    justifyContent: 'center', 
    fontSize: '.94em',
    width: '100%',            
    textAlign: 'center',      
  
                     }}>
                        <div
                            style={{
                                marginBottom: '2em',
                                minHeight: '5.75em',
                                maxHeight: '7.6em',
                                overflowX: 'hidden',
                                overflowY: 'scroll',
                                maxWidth: '38em',
                                fontSize: '.8em',
                            }}>
                        </div>
                        <div
                            style={{
                                height: '5.9em',
                            }}>
                            <div
                                style={{
                                    display: 'inline-block',
                                    width: '15px',
                                    height: '10px',
                                    border: '.0625em solid black',
                                    boxSizing: 'border-box',
                                    backgroundColor: 'green',
                                }}>
                                <svg style={{ margin: '-1px' }} viewBox='0 0 1250 700'>
                                    <path style={{ fill: '#ffffff' }} d='M977 46l21 26c-87,55 -183,142 -289,257 -106,117 -187,225 -244,325l-45 26c-38,22 -63,38 -76,49 -6,-17 -17,-43 -35,-79l-17 -34c-24,-48 -46,-84 -68,-107 -21,-23 -44,-38 -70,-46 44,-40 84,-59 120,-59 31,0 66,36 104,108l18 36c69,-99 156,-195 263,-287 107,-93 213,-165 315,-214l1 -2z' />
                                </svg>
                            </div>&nbsp;
                            {window.gettext('Correct answer filled by student')}
                            <br />
                            <div
                                style={{
                                    display: 'inline-block',
                                    width: '15px',
                                    height: '10px',
                                    border: '.0625em solid black',
                                    boxSizing: 'border-box',
                                    backgroundColor: '#ed3237',
                                }}>
                                <svg style={{ margin: '-1px' }} viewBox='0 0 1250 700'>
                                    <path style={{ fill: '#ffffff' }} d='M584 523l-10 14c-67,102 -122,153 -165,153 -49,0 -98,-40 -146,-121 6,0 11,1 14,1 56,0 119,-43 188,-129l18 -22 -23 -24c-63,-67 -95,-124 -95,-171 0,-38 35,-84 104,-136 10,67 39,132 89,195l19 25 15 -20c72,-92 137,-138 196,-138 46,0 80,35 104,104 -7,-1 -12,-1 -15,-1 -21,0 -50,14 -87,42 -37,28 -69,59 -95,94l-19 26 19 18c69,67 142,100 217,100 -41,82 -83,123 -126,123 -40,0 -97,-35 -172,-105l-30 -27z' />
                                </svg>
                            </div>&nbsp;
                            {window.gettext('Incorrect answer filled by student')}
                            <br />
                            <div
                                style={{
                                    display: 'inline-block',
                                    width: '15px',
                                    height: '10px',
                                    border: '.0625em solid black',
                                    boxSizing: 'border-box',
                                    backgroundColor: '#ffffff',
                                }}>
                                <svg style={{ margin: '-1px' }} viewBox='0 0 1250 700'>
                                    <path style={{ fill: 'green' }} d='M977 46l21 26c-87,55 -183,142 -289,257 -106,117 -187,225 -244,325l-45 26c-38,22 -63,38 -76,49 -6,-17 -17,-43 -35,-79l-17 -34c-24,-48 -46,-84 -68,-107 -21,-23 -44,-38 -70,-46 44,-40 84,-59 120,-59 31,0 66,36 104,108l18 36c69,-99 156,-195 263,-287 107,-93 213,-165 315,-214l1 -2z' />
                                </svg>
                            </div>&nbsp;
                            {window.gettext('Correct answer not filled by student')}
                        </div>
                        <div style={{ marginRight: '-2em' }}>
                            {_.map(Array(columns), (value, column) => <div
                                key={column}
                                style={{
                                    float: 'left',
                                    marginRight: this.props.examination.paper_type === 14 ? '.5em' : '2em',
                                    fontSize: '.9em',
                                    lineHeight: '1em',
                                }}>
                                {_.map(
                                    Array(questionsPerColumn),
                                    (value, row) => (this.state.data.questions[column * questionsPerColumn + row] || { options: 0 }).options > 0
                                        ? <div
                                            key={row}
                                            style={{ display: 'inline-block', float: 'left', clear: 'both' }}>
                                            <div
                                                dir='ltr'
                                                style={{
                                                    width: '2em',
                                                    float: 'left',
                                                    marginTop: '.05em',
                                                    marginBottom: '-.08em',
                                                    fontSize: '.85em',
                                                }}>
                                                {(column * questionsPerColumn + row + 1).persian()}.
                                            </div>
                                            {_.map(
                                                Array((this.state.data.questions[column * questionsPerColumn + row] || { options: 0 }).options),
                                                (value, option) => <div
                                                    key={option}
                                                    style={{
                                                        width: '15px',
                                                        height: '10px',
                                                        margin: '.1em',
                                                        float: 'left',
                                                        border: '.0625em solid black',
                                                        boxSizing: 'border-box',
                                                        backgroundColor: this.state.data.questions[column * questionsPerColumn + row]
                                                            ? (this.state.data.answers != null && this.state.data.answers[column * questionsPerColumn + row] & (1 << option))
                                                                ? this.state.data.key[column * questionsPerColumn + row] === '0'
                                                                    ? undefined
                                                                    : this.state.data.key[column * questionsPerColumn + row] & (1 << option)
                                                                        ? 'green'
                                                                        : '#ed3237'
                                                                : undefined
                                                            : '#dddddd',
                                                    }}>
                                                    {/* خونه های 4 گزینه ای */}
                                                    <svg style={{ margin: '-1px' }} viewBox='0 0 1250 700'>
                                                        {this.state.data.questions[column * questionsPerColumn + row]
                                                            ? this.state.data.key[column * questionsPerColumn + row] & (1 << option)
                                                                ? (this.state.data.answers != null && this.state.data.answers[column * questionsPerColumn + row] & (1 << option))
                                                                    ? <path style={{ fill: '#ffffff' }} d='M977 46l21 26c-87,55 -183,142 -289,257 -106,117 -187,225 -244,325l-45 26c-38,22 -63,38 -76,49 -6,-17 -17,-43 -35,-79l-17 -34c-24,-48 -46,-84 -68,-107 -21,-23 -44,-38 -70,-46 44,-40 84,-59 120,-59 31,0 66,36 104,108l18 36c69,-99 156,-195 263,-287 107,-93 213,-165 315,-214l1 -2z' />
                                                                    : <path style={{ fill: 'green' }} d='M977 46l21 26c-87,55 -183,142 -289,257 -106,117 -187,225 -244,325l-45 26c-38,22 -63,38 -76,49 -6,-17 -17,-43 -35,-79l-17 -34c-24,-48 -46,-84 -68,-107 -21,-23 -44,-38 -70,-46 44,-40 84,-59 120,-59 31,0 66,36 104,108l18 36c69,-99 156,-195 263,-287 107,-93 213,-165 315,-214l1 -2z' />
                                                                : this.state.data.answers != null && this.state.data.answers[column * questionsPerColumn + row] & (1 << option)
                                                                    ? <path style={{ fill: '#ffffff' }} d='M584 523l-10 14c-67,102 -122,153 -165,153 -49,0 -98,-40 -146,-121 6,0 11,1 14,1 56,0 119,-43 188,-129l18 -22 -23 -24c-63,-67 -95,-124 -95,-171 0,-38 35,-84 104,-136 10,67 39,132 89,195l19 25 15 -20c72,-92 137,-138 196,-138 46,0 80,35 104,104 -7,-1 -12,-1 -15,-1 -21,0 -50,14 -87,42 -37,28 -69,59 -95,94l-19 26 19 18c69,67 142,100 217,100 -41,82 -83,123 -126,123 -40,0 -97,-35 -172,-105l-30 -27z' />
                                                                    : null
                                                            : null
                                                        }
                                                    </svg>
                                                </div>,
                                            )}
                                        </div>
                                        : null
                                )}
                            </div>)}
                        </div>
                    </div>

                </div>


                <hr style={{ clear: 'both' }} />
                <div style={{ textAlign: 'center', width: '100%', lineHeight: '2em' }}>
                    {window.gettext('Question Index')} - {window.gettext('Material')} - {window.gettext('Subject')}&nbsp;
                    ({window.gettext('Correct Option')} - {window.gettext('Student Option')})&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ color: 'green' }}>{window.gettext('Correct') + ' '}</span>
                    <span style={{ color: 'red' }}>{window.gettext('Incorrect') + ' '}</span>
                    <span style={{ color: 'black' }}>{window.gettext('Empty') + ' '}</span>
                </div>
                <div
                    style={{
                        width:'100%',
                        clear: 'both',
                        display: 'flex',
                        flexDirection: 'column',
                        flexWrap: 'wrap',
                        height:"maxHeight",
                        fontSize: '.9em',
                        // border: styles.table.border,
                        padding: '.5em',
                    }}>
                    {(() => {
  const allQuestions = this.state.data.questions;
  const questionsPerColumn = Math.ceil(allQuestions.length / 3); 
  const columnCount = 5;


  const columns = Array.from({ length: columnCount }, (_, columnIndex) => {
    const startIndex = columnIndex * questionsPerColumn;
    const endIndex = startIndex + questionsPerColumn;
    return allQuestions.slice(startIndex, endIndex);
  });

  return (
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '20px',
      alignItems: 'flex-start'
    }}>
      {columns.map((columnQuestions, columnIndex) => {
        const startIndex = columnIndex * questionsPerColumn;

        return (
          <div key={columnIndex} style={{
            // flex: '1 1 18%', 
            minWidth: '180px',
            display: 'flex',
            flexDirection: 'column',
            // gap: '0.5em'
          }}>
            {columnQuestions.map((questionInfo, localIndex) => {
              const globalIndex = startIndex + localIndex;
              if (!questionInfo)
                return <div key={globalIndex} style={{
                  height: '1.7em',
                  marginLeft: '.2em',
                  color: 'black',
                  marginBottom: '0.3em'
                }}>
                  {(globalIndex + 1).persian()} - {window.gettext('This question is removed.')}
                </div>;

              const { material, subjects } = questionInfo;

             
              const isNewMaterial = globalIndex === 0 || 
                (allQuestions[globalIndex - 1]?.material !== undefined && allQuestions[globalIndex - 1]?.material !== material );

              return (
                <div key={globalIndex}>
                  {isNewMaterial && (
                    <div style={{
                      fontWeight: 'bold',
                      marginTop: localIndex > 0 ? '10px' : '0',
                      marginBottom: '5px',
                      padding: '2px 5px',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '3px',
                      textAlign:'center'
                    }}>
                      {material?.persian()}
                    </div>
                  )}
                  
                  <div style={{ 
                    height: '1.7em', 
                    marginLeft: '.2em',
                    marginBottom: '0.3em',
                    fontSize: window.mobile ? '0.9em' : '1em',
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                    <span
                      style={{
                        color: this.state.data.answers != null && this.state.data.answers[globalIndex]
                          ? this.state.data.key[globalIndex] === this.state.data.answers[globalIndex]
                            ? 'green'
                            : 'red'
                          : undefined,
                        fontWeight: 'bold',
                        minWidth: '10px',
                        display: 'inline-block'
                      }}>
                      {(globalIndex + 1).persian()}
                    </span>
                    &nbsp;-&nbsp;
                    {(text => text.length > (window.mobile ? 15 : 22)
                      ? text.persian()
                      : text.persian())(subjects.join(window.gettext(',')))}
                    &nbsp;
                    <span style={{ fontSize: '0.9em' }}>
                      ({Math.log2(this.state.data.key[globalIndex] * 2 || 1).toFixed().persian()}
                      &nbsp;-&nbsp;
                      <span
                        style={{
                          color: this.state.data.answers != null && this.state.data.answers[globalIndex]
                            ? this.state.data.key[globalIndex] === this.state.data.answers[globalIndex]
                              ? 'green'
                              : 'red'
                            : undefined,
                          fontWeight: 'bold'
                        }}>
                        {Math.log2((this.state.data.answers === undefined ? 0 : this.state.data.answers[globalIndex]) * 2 || 1).toFixed().persian()}
                      </span>)
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
})()}

                </div>
            </span>
            }
            </div>
        </span>;
    }

    renderSubjectReport() {
        return <div>
            <div style={{ display: 'inline-block', maxWidth: '100%', marginBottom: '.5em' }}>
                {_.map(this.props.examination.materials, (material, index) => {
                    const data = this.state.data.materials[material.id];
                   
                    return <div
                        style={{
                            // ...styles.buttonContainer,
                            float: 'right',
                            marginLeft: '1px',
                        }}>
                        <button
                            key='0'
                            style={{
                                ...(this.state.currentMaterial === index
                                    ? styles.activeButton
                                    : styles.button),
                                backgroundColor: (data?.status ?? -1) >= 0  ? color({
                                    0: '#B22222',
                                    1: 'orange',
                                    2: 'yellow',
                                    3: 'green',
                                    4: '#006400',
                                }[data?.status ?? -1]).lighten(.5).hex() : '#aaa',
                                border: this.state.currentMaterial === index ? '.125em solid black' : 'none',
                                padding: this.state.currentMaterial === index ? '.375em' : '.5em',
                            }}
                            onClick={() => this.setState({ currentMaterial: index })}>
                            {material.title.persian()}
                        </button>
                        
                    </div>;
                })}
            </div>
            <div style={{overflow:"auto"}}>
            <table style={{...styles.table , maxWidth:"100%" , paddingLeft:"1rem"}}>
                <thead style={{ backgroundColor: '#cccccc' }}>
                    <tr>
                        <th
                            rowSpan='2'
                            style={{ ...styles.th, width: '12em' }}>
                            {window.gettext('Subject')}
                        </th>
                        {_.map(
                            ['count', 'correct', 'incorrect', 'empty', 'score', 'alternative_score', 'taraz'],
                            title => <th
                                key={title}
                                rowSpan='2'
                                style={{ ...styles.th, width: title.includes('score') ? '5.5em' : '4em' }}>
                                {window.gettext(_.startCase(title))}
                            </th>,
                        )}
                        <th colSpan='3' style={{ ...styles.th, width: '12em' }}>
                            {window.gettext('Rank')}
                        </th>
                        <th rowSpan='2' style={{ ...styles.th, width: '6em' }}>
                            {window.gettext('Status')}
                        </th>
                    </tr>
                    <tr>
                        <th style={{ ...styles.th, width: '4em' }}>
                            {window.gettext('Class')}
                        </th>
                        <th style={{ ...styles.th, width: '4em' }}>
                            {window.gettext('School')}
                        </th>
                        <th style={{ ...styles.th, width: '4em' }}>
                            {window.gettext('Global')}
                        </th>
                    </tr>
                </thead>
                {_.map(['global', ..._.filter(
                    this.props.examination.subjects,
                    subject => subject.material?.id === this.props.examination.materials[this.state.currentMaterial].id,
                )], subject => {

                    const data = subject === 'global'
                    ? this.state.data.materials[this.props.examination.materials[this.state.currentMaterial].id]
                    : this.state.data.subjects[subject.id];
                if(!data){
                    return null;
                }
                return <tr
                        style={styles.tr}
                        key={subject.id || subject}>
                        <td
                            style={{
                                ...styles.td,
                                width: '12em',
                                textAlign: 'right',
                                fontWeight: subject === 'global' ? '700' : undefined,
                                backgroundColor: (data?.status ?? -1) >= 0 ? color({
                                    0: '#B22222',
                                    1: 'orange',
                                    2: 'yellow',
                                    3: 'green',
                                    4: '#006400',
                                }[data?.status ?? -1]).lighten(.5).hex() : "#fff",
                            }}>
                            {
                            subject === 'global'
                                ? 
                                this.props.examination.materials[this.state.currentMaterial].title.persian()
                                : subject.title.persian() + '\u00A0\u00A0\u00A0'
                            }
                        </td>
                        {
                            data ?
                        _.map(
                            ['count', 'correct', 'incorrect', 'empty', 'score', 'alternative_score', 'taraz'],
                            title => <td
                                style={{
                                    ...styles.td,
                                    width: title.includes('score') ? '5.5em' : '4em',
                                    textAlign: 'center',
                                }}>
                                {(value => value !== undefined
                                    ? title.includes('score')
                                        ? value.toPercent().persian()
                                        : value.toFixed().persian()
                                    : '-'
                                )(data[title])}
                            </td>,
                        ) :
                        null}
                        {data ? _.map(
                            ['class', 'school', 'global'],
                            title => <td
                                style={{
                                    ...styles.td,
                                    width: title.includes('score') ? '5.5em' : '4em',
                                    textAlign: 'center',
                                }}>
                                {(value => value !== undefined
                                    ? value.toFixed().persian()
                                    : '-'
                                )((data[title] || {}).rank)}
                            </td>,
                        ) : null}
                        <td
                            style={{
                                ...styles.td,
                                width: '6em',
                                textAlign: 'center',
                                backgroundColor:(data?.status ?? -1) >= 0 ? color({
                                    0: '#B22222',
                                    1: 'orange',
                                    2: 'yellow',
                                    3: 'green',
                                    4: '#006400',
                                }[data?.status ?? -1]).lighten(.5).hex() : "#fff",
                            }}>
                            {(data.status ?? -1) >= 0 ? window.gettext(`examination-Status-${data?.status ?? -1}`) :"-"}
                        </td>
                    </tr>;
                })}
            </table>
            </div>
        </div>;
    }

    async fetchShabihSazReport(){
        var token = this.context.store.getState().get('application').get('token');
        var auth = token.get('accessToken');
        const url = `${host}/api/examination/${this.props.examination.id}/report/shabihsaz/`;
        const res = await fetch(url ,{
            method: 'POST',
            body: JSON.stringify({student:this.props.student ?? this.context.user.id}),
            headers: {
                Authorization: 'Bearer ' + auth,
                'Content-Type': 'application/json'
            },
        }
        );
        const data = await res.json()
        if(data.length == 0){
            this.setState({currentTab : 0})
        }
        else if(data.length != 0 && data != "examination grade must be sixth or nineth") {
            this.setState({currentTab:2})
        }
        this.setState({...this.state , shabihsazData:data});
    }

    renderBasicReport(){

        return <div style={{width:"100%"}}>
            {this.props.examination.grades[0].id === 4&& 
            <>
            <div style={{overflow:"auto"}}>
            <table style={{...styles.table , width:"100%" , marginBottom:"1rem"}}>
            <thead style={{ backgroundColor: '#cccccc' }}>
                <tr style={styles.tr}>
                    {["عنوان ماده امتحانی","ضریب سوال","حداکثر نمره ممکن","تعداد پاسخ درست","تعداد پاسخ غلط","تعداد بدون پاسخ","نمره با ضریب"].map((item , index)=>(
                        <th style={styles.th } colSpan={index === 0 ? 2 : 1}>{window.gettext(item)}</th>
                    ))}
                </tr> 
            </thead>
            <tbody>
                    {this.state?.shabihsazData?.materials?.[1]?.materials?.map((item, index) => (
                        <tr key={`sub-${index}`} style={styles.tr}>
                         {index === 0 && (
                              <td
                             style={styles.td}
                             rowSpan={
                                  this.state?.shabihsazData?.materials?.[1]?.materials?.length || 1
        }
                              >
                               استعداد تحصیلی
                             </td>
                            )}
                            <td style={styles.td}>{item?.title ? item.title.persian() : "-"}</td>
                            <td style={styles.td}>{item?.coefficient ? item.coefficient.persian() : "-"}</td>
                            <td style={styles.td}>{item?.max_score ? item.max_score.persian() : "-"}</td>
                            <td style={styles.td}>{item?.correct ? item.correct.persian() : "-"}</td>
                            <td style={styles.td}>{item?.incorrect ? item.incorrect.persian() : "-"}</td>
                            <td style={styles.td}>{item?.empty ? item.empty.persian() : "-"}</td>
                            <td style={styles.td}>{item?.score ? item.score.persian() : "-"}</td>
                        </tr>
                        ))}

                        {this.state?.shabihsazData?.materials
                        ?.filter(item => !item?.materials)
                        ?.map((item, index) => (
                            <tr key={`main-${index}`} style={styles.tr}>
                              <td style={styles.td} colSpan={2}>{item?.title || "-"}</td>
                              <td style={styles.td}></td>
                              <td style={styles.td}>{item?.max_score ? item.max_score.persian() : "-"}</td>
                              <td style={styles.td}>{item?.correct ? item.correct.persian() : "-"}</td>
                              <td style={styles.td}>{item?.incorrect ? item.incorrect.persian() : "-"}</td>
                              <td style={styles.td}>{item?.empty ? item.empty.persian() : "-"}</td>
                              <td style={styles.td}>{item?.score ? item.score.persian() : "-"}</td>
                            </tr>
)                       )}
            </tbody>
            </table>
            </div>
            <table style={{...styles.table , width:"100%"}}>
                <tr style={styles.tr}>
                    <td style={styles.td}>نمره دفترچه استعداد تحصیلی از {"100".persian()} : <b>{this?.state?.shabihsazData?.tahsili_score ? this?.state?.shabihsazData?.tahsili_score.persian() : "-"}</b></td>
                    <td style={styles.td}>نمره دفترچه استعداد تحلیلی از {"100".persian()} :  <b>{this?.state?.shabihsazData?.tahlili_score ? this?.state?.shabihsazData?.tahlili_score.persian() : "-"}</b></td>
                    <td style={styles.td}>معدل کتبی ارزشیابی نوبت دوم از پایه نهم {"20".persian()} :  <b>{"19".persian()}</b></td>
                </tr>
                <tr style={styles.tr}>
                    <td style={styles.td} colSpan={2}>نمره با فرمول سمپاد از {"100000".persian()} : <b>{this?.state?.shabihsazData?.sampad_score ? this?.state?.shabihsazData?.sampad_score.persian() : "-"}</b></td>
                    <td style={styles.td}>نمره با فرمول نمونه دولتی از {"100000".persian()} : <b>{this?.state?.shabihsazData?.nemone_score ? this.state.shabihsazData.nemone_score.persian() : "-"}</b></td>
                </tr>
            </table>
            <p style={{marginTop:"1rem" , display:"flex", alignItems:"center"}}>
                <span style={{color:"red" , fontSize:"1.2rem"}}>*</span>
                <span>معدل پایه برای محاسبه نمره نمونه دولتی، عدد </span>
                &nbsp;<span>{"«19»".persian()}</span>&nbsp;
                <span>در نظر گرفته شده است. هر نمره اضافه یا کم نسبت به این معدل پایه، به ترتیب </span>
                &nbsp;<span>{"«1500»".persian()}</span>&nbsp;
                <span>نمره به امتیاز نهایی شما اضافه یا از آن کم خواهد شد.</span>
            </p>
            </>
            }
            {this.props.examination.grades[0].id === 6 && 
            <table style={{...styles.table , width:"100%" }}>
                <thead style={{ backgroundColor: '#cccccc' }}>
                    <tr style={styles.tr}>
                        {["عنوان ماده امتحانی","تعداد پاسخ صحیح","تعداد پاسخ غلط","تعداد نزده","امتیاز داوطلب"].map((item , index)=>(
                            <th style={styles.th }>{window.gettext(item)}</th>
                        ))}
                    </tr> 
                </thead>
                <tbody>
                    
                    {this.state?.shabihsazData?.materials?.map((item)=>(
                        <tr style={styles.tr}>
                            <td style={styles.td}>{item.title ? item.title.persian() : "-"}</td>
                            <td style={styles.td}>{item.correct ? item.correct.persian() : "-"}</td>
                            <td style={styles.td}>{item.incorrect ? item.incorrect.persian() : "-"}</td>
                            <td style={styles.td}>{item.empty != (null || undefined) ? item.empty.persian(): "-"}</td>
                            <td style={styles.td}>{item.score ? item.score.persian() :"-"}</td>
                        </tr>
                    ))}
                    <tr style={styles.tr}>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style={styles.td}>امتیاز کل</td>
                        <td style={styles.td}>{this.state.shabihsazData.score ? this.state.shabihsazData?.score.persian() : "-"}</td>
                    </tr>
                </tbody>
            </table>
            }
        </div>
    }

    render() {
        if(this.state.portalShow && (this.context.user.type[0]=="manager" || this.context.user.type[0]=='student') && (this.props.examination.examination_type?.id === (1 || 2) )){
            return <Portal> 
                <div className="portal-container"> 
                    <div className="portal-content">
                        <div className="text-box">
                            <p className='portal-text'>کارنامه در حال بروزرسانی می باشد لطفا شکیبا باشید</p>
                            <button className="portal-btn" 
                            onClick={()=>{this.setState({portalShow:false})}}
                            >تایید</button>
                        </div>
                    </div>
                </div> 
            </Portal>
            }
        else return <span>
            {this.props.examination.entrance_examination && this.state.showEntranceAnalyze ?
                <div style={{textAlign:'center'}}>
                    <p style={{marginBottom:'10px'}}>
                        دوست داری بدونی تو آزمون سال پیش قبول می‌شدی یا نه؟ 
                    </p>
                    <a style={{
                          ...styles.defaultButton,
                                textDecoration: 'none',
                                display: 'inline-block',
                                marginRight: '.5em',
                                backgroundColor: styles.thirdColor,
                    }} href={`https://tahlil.mhelli.com/Home/LoginUser?provinceId=${this.context.user.region ?? 0}&gender=${this.context.user.gender ?? 0}&examId=${this.props.examination.id}`}
                    onClick={ () =>
                        this.setState({ showEntranceAnalyze: false })
                    }
                    >آره</a>
                    <button style={{
                        ...styles.defaultButton,
                        marginRight: '.5em',
                        backgroundColor: styles.fourthColor,
                    }}
                    onClick={ () =>
                        this.setState({ showEntranceAnalyze: false })
                    }>
                        نه
                    </button>
                </div> 
            : ''}
            <div style={{ marginBottom: '.5em', display: 'inline-block', float: 'left' }}>
                <div style={{overflow:"hidden" , height:"0"}}>
                <iframe
                    ref='print'
                    style={{ width: '0', height: '0', border: 'none' }}
                    srcDoc={`<html>
    <head>
        <link rel='stylesheet' type='text/css' href='`+window.location.origin+`/css/mhelli.css'>
        <style>
            @page {
                size: A4 Portrait;
                margin: 0;
            }
            body {
                background-color: white;
            }
        </style>
    </head>
    <body dir='rtl'>
        <span id='content'>
            <span>1</span><span style='font-weight: 700;'>2</span>
        </span>
    </body>
</html>`} />
                </div>

                <div>
                    {this.state.printing
                        ? <i className='fa-spin fa-spinner fa-2x'></i>
                        : this.props.examination.analyze_date == null ? null : 
                        <button
                            key='print'
                            style={{
                                ...styles.defaultButton,
                                float: 'left',
                                marginRight: '.5em',
                                backgroundColor: styles.fourthColor,
                            }}
                            onClick={async () => {
                                this.setState({ printing: true });
                                const win = this.refs.print.contentWindow;
                                ReactDom.unmountComponentAtNode(win.document.getElementById('content'));
                                ReactDom.render(<StyleRoot>
                                    <PrintStudentReport
                                        imageLoaded={() => {
                                            // win.print();
                                            PrintMyContent(this.refs.print , ()=>{this.setState({printing: false})})
                                        }}
                                        last
                                        data={{ ...this.props, ...this.state.data }}
                                        // shabihsazData={this.state.shabihsazData}
                                        examination={this.props.examination} />
                                </StyleRoot>, win.document.getElementById('content'));
                            }}>
                            {window.gettext('Print')}
                        </button>
                    }
                    {this.props.urls.back
                        ? <button
                            key='close'
                            style={{ ...styles.button, float: 'left', marginRight: '.5em' }}
                            onClick={() => this.context.store.dispatch(push(this.props.urls.back.format(this.props.params)))}>
                            {window.gettext('Back')}
                        </button>
                        : null
                    }
                </div>
            </div>
            {this.state.data
                ? <div
                    style={{
                        ...styles.box,
                        width: '100%',
                        display: 'inline-block',
                    }}>
                    <div style={{ float: 'right', width:window.mobile? '50%':'25%' }}>
                        {window.gettext('Examination')}: {this.props.examination.title}
                    </div>
                    <div style={{ float: 'right', width:window.mobile? '50%':'25%'  }}>
                        {"نوع آزمون"}: {(this.state.data.register_online === true ? ("آنلاین") : ("کاغذی"))}
                    </div>
                    {
                        this.state.data.examination_type === 6
                        ? 
                        <div style={{ float: 'right', width:window.mobile? '50%':'25%'  }}>
                            {"درجه سختی آزمون"}: {window.gettext(`Difficulty Level ${this.state.data.difficulty_level}`)}
                        </div>
                        : 
                        null
                    }
                    <div style={{ float: 'right', width:window.mobile? '50%':'25%'  }}>
                        {window.gettext('Name')}: {this.state.data.firstname} {this.state.data.lastname}
                    </div>
                    <div style={{ float: 'right', width:window.mobile? '50%':'25%'  }}>
                        {window.gettext('National ID')}: {this.state?.data?.national_id?.persian()}
                    </div>
                    <div style={{ float: 'right', width:window.mobile? '50%':'25%'  }}>
                        {window.gettext('Holding Date')}: {this.props.examination.end ? this.props.examination.date.toJalali().persian() : ''}
                    </div>
                    <div style={{ float: 'right',width:window.mobile? '50%':'25%'  }}>
                        {window.gettext('رتبه کشوری')}: {(this.state.data?.global !== undefined && this.state.data?.global?.global && this.state?.data?.global?.global.rank || '-').persian()}
                    </div>
                     <div style={{ float: 'right',width:window.mobile? '50%':'25%'  }}>
                        {window.gettext('تعداد شرکت کنندگان کشوری')}: {this.getParticipants().persian()}
                    </div>
                    <div style={{ float: 'right',width:window.mobile? '50%':'25%'  }}>
                        {window.gettext('رتبه استانی')}: {(this.state.data?.global !== undefined && this.state.data?.global?.region && this.state?.data?.global?.region.rank || '-').persian()}
                    </div>
                     <div style={{ float: 'right',width:window.mobile? '50%':'25%'  }}>
                        {window.gettext('تعداد شرکت کنندگان استانی')}: {(this.state.data.region_participants).persian()}
                    </div>
                    <div style={{ float: 'right', width: window.mobile ? '50%' : '25%' }}>
                                {window.gettext('Region')}: {this.state.data?.region_display}
                    </div>
                    {/* {((this.context.user.type[0] !== 'student') ? 
                        <div>
                            <div style={{ float: 'right', width: window.mobile ? '50%' : '25%' }}>
                                {window.gettext('Region')}: {this.state.data?.region_display}
                            </div>
                            <div style={{ float: 'right', width: window.mobile ? '50%' : '25%' }}>
                                {window.gettext('City')}: {this.state.data?.city_display}
                            </div>
                            <div style={{ float: 'right', width: window.mobile ? '50%' : '25%' }}>
                                {window.gettext('Analyze Date')}: {this.props.examination.analyze_date
                                    ? this.props.examination.analyze_date.toJalali().persian()
                                    : ''
                                }
                            </div>
                            <div style={{ float: 'right', width:window.mobile? '50%':'25%'  }}>
                                {window.gettext('Centers Participated')}: {(this.state.data.centers || '').persian()}
                            </div>
                            <div style={{ float: 'right', width:window.mobile? '50%':'25%'  }}>
                                {window.gettext('Participants')}: {this.getParticipants().persian()}
                            </div>
                        </div>
                        : null
                    )} */}
                    {/* {
                        this.props.examination.entrance_examination ?
                        <div style={{ float: 'right', width:window.mobile? '50%':'25%'  }}>
                        {"وضعیت قبولی"}: {this.state.data.acceptance_type ===1 ?  
                        
                        <span style={{color:styles.successColor}}>قبول شده</span>

                        :this.state.data.acceptance_type ===2 ? 

                        <span style={{color:styles.warningColor}}>لیست انتظار</span>                        
                        :  
                        <span style={{color:styles.warningColor}}>رد شده</span>}
                    </div>:null
                    } */}
                </div>
                : null
            }
            <div
                style={{
                    ...styles.box,
                    marginTop: '1em',
                    width: '100%',
                    display: 'inline-block',
                }}>
                {this.props.examination.advanced_report || this.state.data 
                    ? <div style={{ display: 'inline-block', width: '100%', marginBottom: '.5em' }}>
                        <div
                            style={{
                                // ...styles.buttonContainer,
                                float: 'right',
                                marginLeft: '1px',
                            }}>
                            {(this.props.examination.grades[0].id == 6 || this.props.examination.grades[0].id == 4 ) && (this.state.shabihsazData.length != 0) &&
                                <button
                                key='2'
                                style={
                                    this.state.currentTab === 2
                                        ? styles.activeButton
                                        : styles.button
                                    }
                                onClick={() => this.setState({ currentTab: 2 })}>
                                    {window.gettext('Basic Report')}
                                </button>
                            }
                            <button
                                key='0'
                                style={
                                    this.state.currentTab === 0
                                        ? styles.activeButton
                                        : styles.button
                                }
                                onClick={() => this.setState({ currentTab: 0 })}>
                                {window.gettext('Pregress Report')}
                            </button>
                        </div>
                        
                        <div
                            style={{
                                // ...styles.buttonContainer,
                                float: 'right',
                                marginLeft: '1px',
                            }}>
                            <button
                                key='0'
                                style={
                                    this.state.currentTab === 1
                                        ? styles.activeButton
                                        : styles.button
                                }
                                onClick={() => this.setState({ currentTab: 1 })}>
                                {window.gettext('subject report')}
                            </button>
                            {
                            this.state.studyProposalData?.studyProposals?.length > 0 ?
                                <button
                                    key='0'
                                    style={
                                        this.state.currentTab === 3
                                            ? styles.activeButton
                                            : styles.button
                                    }
                                    onClick={() => this.setState({ currentTab: 3 })}>
                                    {window.gettext('Recommendation')}
                                </button>
                                : 
                                null
                                }
                        </div>
                        <div style={{ display: this.state.currentTab === 1 ? undefined : 'none', float: 'left' }}>
                            <div style={{ float: 'right', marginTop: '.5em', marginRight: '1.5em' }}>
                                {window.gettext('Help')}:&nbsp;
                            </div>
                            {_.map(new Array(5), (__, index) => <div
                                key={'status-' + index}
                                style={{
                                    float: 'right',
                                    marginRight: '1px',
                                    padding: '.5em',
                                    backgroundColor: color({
                                        0: '#B22222',
                                        1: 'orange',
                                        2: 'yellow',
                                        3: 'green',
                                        4: '#006400',
                                    }[4 - index]).lighten(.5).hex(),
                                }}>
                                {window.gettext(`examination-Status-${4 - index}`)}
                            </div>)}
                        </div>
                    </div>
                    : null
                }
                {this.state.currentTab === 0
                    ? this.renderProgressReport.bind(this)()
                : null
                }
                {/* کارنام*/}
                {this.state.currentTab === 1
                    ? (
                        <>
                            {this.renderSubjectReport.bind(this)()}
                        </>
                    )
                    : null
                }
                {/* کارنامه پایه */}
                {this.state.currentTab === 2 
                    ? this.renderBasicReport.bind(this)()
                : null
                }
                {/* توصیه نامه */}
                {(this.state.currentTab === 3 )
                    ?  this.renderStudyProposal.bind(this)()
                : null
                }
            </div>
        </span>;
    }
};
window.gettext('Count');
window.gettext('Coefficient');
window.gettext('Correct');
window.gettext('Incorrect');
window.gettext('Empty');
window.gettext('Score');
window.gettext('Alternative Score');
window.gettext('Taraz');
window.gettext('Status-0');
window.gettext('Status-1');
window.gettext('Status-2');
window.gettext('Status-3');
window.gettext('Status-4');
